import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_search" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
      placeholder: "Iskanje",
      type: "text"
    }, null, 512), [
      [_vModelText, _ctx.localValue]
    ]),
    _hoisted_2
  ]))
}